/**
 * Homepage Sticky Footer
 * 
 */
"use strict";

export class StickyFooter {

  /**
   * Constructor 
   */
  constructor() {
    const sticky = document.querySelector('.sticky-footer');
    const isClosed = sessionStorage.getItem('Footer-Cnt');

    if ( ! sticky ) return;
    
    if ( isClosed && isClosed == 1 )
      sticky.classList.add('hidden');
    
    sticky.querySelector('a.close').addEventListener('click', ( e ) => {
      e.preventDefault();

      sticky.classList.add('hidden');

      sessionStorage.setItem('Footer-Cnt', '1');
    });
  }
}